/* eslint-disable prettier/prettier */

/* eslint-disable no-inner-declarations */

/* eslint-disable no-console */

/* eslint-disable array-callback-return */
import React, { useEffect } from 'react';
import { Button } from 'antd';
import { withTranslation } from 'react-i18next';
import { capturarToken, login, urlDestino } from '../UtilsLogin/UtilsLogin';
import { storeArq } from 'correos-arq-utils';

var Login = function Login(props) {
  try {
    var t = props.t,
        rolesWeb = props.rolesWeb,
        instance = props.instance,
        tipo_integracion = props.tipo_integracion;
    storeArq.load();
    useEffect(function () {
      var regex = /^(correosid|isam)$/i;

      if (regex.test(tipo_integracion)) {
        if (tipo_integracion === "correosid") {
          storeArq.data.tipo_integracion = "EXTERN";
          storeArq.save();
        } else {
          storeArq.data.tipo_integracion = "INTERN";
          storeArq.save();
        }
        /* // FLUJOS //
        flujo 1: si hay token en la url, procesa ese token y le da todos los permisos.
        flujo 2: si no lo hay, se redirige al ISAM de vuelta deberá tener ese token y seguirá el flujo 1. */


        if (storeArq.data.idTokenNoVal !== '') {
          capturarToken(instance, rolesWeb);
        } else {
          if (storeArq.data.tipo_integracion !== '' && tipo_integracion !== '') {
            login(urlDestino(''));
          }
        }
      } else {
        throw new Error("Invalid prop tipo_integracion passed to Login.js. Expected a valid tipo integracion.");
      }
    });
    var token = storeArq.data.idTokenNoVal;
    var buttonLogin;

    if (token === '') {
      buttonLogin = /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          top: '1.786em'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "primary"
      }, t('components_shared_Login.btnLogin')));
    } else {
      buttonLogin = '';
    }

    return /*#__PURE__*/React.createElement("div", null, buttonLogin);
  } catch (error) {
    throw new Error("Error ".concat(error));
  }
};

export default withTranslation()(Login);